"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDownloadFilled = function IconDownloadFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 29.0466C9.99916 27.5406 10.3824 26.0592 11.1134 24.7425C11.8444 23.4258 12.899 22.3172 14.1777 21.5215C14.5152 18.8901 15.8 16.4718 17.7917 14.7193C19.7834 12.9667 22.3454 12 24.9984 12C27.6513 12 30.2134 12.9667 32.2051 14.7193C34.1968 16.4718 35.4816 18.8901 35.819 21.5215C37.4051 22.5083 38.6388 23.9709 39.3441 25.7006C40.0493 27.4303 40.19 29.3386 39.7461 31.153C39.3021 32.9674 38.2963 34.5952 36.8721 35.8039C35.4479 37.0126 33.6783 37.7404 31.8158 37.8834L18.1809 37.9093C13.6051 37.5357 10 33.7125 10 29.0466ZM31.6086 35.1646C32.8982 35.0654 34.1235 34.5613 35.1095 33.7241C36.0954 32.887 36.7916 31.7596 37.0986 30.5032C37.4056 29.2467 37.3076 27.9253 36.8188 26.7278C36.3299 25.5304 35.4751 24.518 34.3765 23.8354L33.2761 23.1495L33.1125 21.8651C32.8576 19.8931 31.8934 18.0814 30.3999 16.7685C28.9065 15.4557 26.9861 14.7316 24.9977 14.7316C23.0093 14.7316 21.0889 15.4557 19.5955 16.7685C18.102 18.0814 17.1378 19.8931 16.8829 21.8651L16.7193 23.1495L15.6217 23.8354C14.5231 24.5179 13.6683 25.5302 13.1794 26.7275C12.6905 27.9249 12.5924 29.2461 12.8992 30.5026C13.206 31.759 13.902 32.8863 14.8878 33.7236C15.8735 34.5608 17.0987 35.0652 18.3882 35.1646L18.6241 35.1823H31.3727L31.6086 35.1646ZM26.3619 25.6379H30.4523L24.9984 32.4553L19.5444 25.6379H23.6349V20.1839H26.3619V25.6379Z",
    fill: color
  }));
};

IconDownloadFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconDownloadFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconDownloadFilled;
exports.default = _default;